import React, {useContext} from "react";
import {RankingsAndLevelsContext} from "../../../contexts/RankingsAndLevelsContext";
import {FlexedDiv, RankingsNavbarDiv, RankingsTitleDiv, RowDivF1} from "../../styledComponents/CustomStyledComponents";
import BackComponent from "../../backComponent/BackComponent";
import Colors from "../../../assets/colors/Colors";

const Separator: React.FC<{customStyle?: object, separatorColor?: string}> = ({customStyle= {}, separatorColor = 'white'}) => {
    return (
        <div style={{display: 'flex', flexDirection: 'row', ...customStyle}}>
            <div style={{flex: 0.15}} />
            <div style={{flex: 0, borderLeft: '1px solid', borderColor: separatorColor, margin: 'auto', height: 30}} />
            <div style={{flex: 0.15}} />
        </div>
    );
};

const TierNavbar: React.FC<{backRoute: string, isLife: boolean, yearCode: string}> = ({backRoute, isLife, yearCode}) => {

    return (
        <RankingsNavbarDiv>
            <RowDivF1>
                <BackComponent
                    backRoute={backRoute}
                    label={"Atrás"}
                    customStyle={{justifyContent: 'center', alignItems: 'center', display: 'flex'}}
                    backColor={isLife ? Colors.fontWhite: Colors.fontGray}
                />
                <Separator customStyle={{marginRight: 20, marginLeft: 20}} separatorColor={isLife ? Colors.fontWhite: Colors.fontGray} />
                <RankingsTitleDiv isLife={isLife}>{yearCode}</RankingsTitleDiv>
            </RowDivF1>
            <FlexedDiv flexValue={6}/>
        </RankingsNavbarDiv>
    )
};

export default TierNavbar;
